import { useState, useMemo } from "react";
import {
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    FormControl,
    FormLabel,
    RadioGroup,
    FormControlLabel,
    Radio,
    Grid,
    Box
} from "@mui/material";
import { TTipoMovimento } from ".";

export default function DialogContentFiltroTipoMovimento({
    handleClose,
    defaultValue,
    onChange
}: DialogContentFiltroTipoBaixaProps) {

    const [filtros, setFiltros] = useState<TTipoMovimento>(defaultValue);

    const opcoesRadio = useMemo(() => [
        { value: "S", label: "Sim" },
        { value: "N", label: "Não" },
    ], []);

    const handleChange = (campo: keyof TTipoMovimento, valor: "S" | "N") => {
        setFiltros(prev => ({
            ...prev,
            [campo]: valor
        }));
    };

    const handleConfirmar = () => {
        onChange(filtros);
    };

    const camposFiltro = [
        { key: '6', label: 'Movimento 6' },
        { key: '7', label: 'Movimento 7' },
        { key: '8', label: 'Movimento 8' },
        { key: '9', label: 'Movimento 9' },
    ];

    return (
        <>
            <DialogTitle>
                Filtros - Tipo de Movimento
            </DialogTitle>
            
            <DialogContent>
                <Box sx={{ pt: 2 }}>
                    <Grid container spacing={3}>
                        {camposFiltro.map((campo) => (
                            <Grid size={{xs: 12, sm: 6}} key={campo.key}>
                                <FormControl>
                                    <FormLabel id={`${campo.key}-label`}>
                                        {campo.label}
                                    </FormLabel>
                                    <RadioGroup
                                        row
                                        aria-labelledby={`${campo.key}-label`}
                                        value={filtros[campo.key as keyof TTipoMovimento]}
                                        onChange={(e) => handleChange(
                                            campo.key as keyof TTipoMovimento, 
                                            e.target.value as "S" | "N"
                                        )}
                                    >
                                        {opcoesRadio.map((opcao, index) => (
                                            <FormControlLabel 
                                                key={index} 
                                                value={opcao.value} 
                                                control={<Radio />} 
                                                label={opcao.label} 
                                            />
                                        ))}
                                    </RadioGroup>
                                </FormControl>
                            </Grid>
                        ))}
                    </Grid>
                </Box>
            </DialogContent>

            <DialogActions>
                <Button onClick={handleClose}>
                    Cancelar
                </Button>
                <Button 
                    onClick={handleConfirmar}
                    variant="contained"
                >
                    Confirmar
                </Button>
            </DialogActions>
        </>
    );
}

interface DialogContentFiltroTipoBaixaProps {
    handleClose: () => void;
    defaultValue: TTipoMovimento;
    onChange: (value: TTipoMovimento) => void;
}